
export const Quesion = "tfQuestion";

export function question() {
    return {
        template: "<ng-transclude></ng-transclude>",
        transclude: true,
        require: {
            question: "^^tfQuizQuestion"
        },
        controllerAs: "ctrl",
        controller: () => {}
    };
}
